// extracted by mini-css-extract-plugin
export default {"wrap":"CompanyLogoFileController_wrap__4NLwD","input":"CompanyLogoFileController_input__4y1DU","img":"CompanyLogoFileController_img__3GcZG"};